import http from 'common-module/src/util/http';

/**
 * 获取缺陷类型统计
 * @param data
 * @return {Promise<*>}
 */
export const getBugTypeStatistics = async (data) => {
  return http.post('/issue-statistic/issue-distribute', data);
};

/**
 * 获取燃尽图统计
 * @param data
 * @return {Promise<*>}
 */
// eslint-disable-next-line
export const getBurndownStatistics = async (data) => {
  // eslint-disable-next-line
  return http.post('/issue-statistic/burndown-chart', data);
};

/**
 * 获取燃尽图统计
 * @param data
 * @return {Promise<*>}
 */
// eslint-disable-next-line
export const getBurndownBeautifyStatistics = async (data) => {
  // eslint-disable-next-line
  return http.post('/issue-statistic/burndown-chart-beautify', data, { showError: false });
};

/**
 * 获取燃起图统计
 * @param data
 * @return {Promise<*>}
 */
// eslint-disable-next-line
export const getBurnupStatistics = async (data) => {
  // eslint-disable-next-line
  return http.post('/issue-statistic/burnup-chart', data, { showError: false });
};

/**
 * 获取累积流图统计
 * @param data
 * @return {Promise<*>}
 */
export const getCumulativeFlowDiagramStatistics = async (data) => {
  return http.post('/cumulative-flow-diagram/list-data', data, { showError: false });
};

/**
 * 获取指派给我的信息
 * @param data
 * @return {Promise<*>}
 */
export const getAssignedHomeWork = async (data) => {
  return http.post('/issue/home-work-v2', data);
};

/**
 * 获取我的留言
 * @param data
 * @return {Promise<*>}
 */
export const getComments = async (data) => {
  return http.post('/sys-comment/home/issue/page-list/reply', data);
};

/**
 * 获取饼图统计纬度
 * @return {Promise<*>}
 */
export const getDimension = async (data) => {
  return http.post('/issue-statistic/dimension/selectors', data);
};

/**
 * 获取指派人默认配置
 * @returns {Promise<undefined>}
 */
export const getAssignedDefaultConfig = async () => {
  return http.post('/sys-home/get/home-assignee-config', {});
};

/**
 * 获取指派人可选条件
 * @returns {Promise<undefined>}
 */
export const getAssignedFilter = async () => {
  return http.post('/sys-home/get/home-assignee-filter', {});
};

/**
 * 获取指派人可选条件的选项
 * @returns {Promise<undefined>}
 */
export const getAssignedFilterOptions = async (data) => {
  return http.post('/sys-home/get/home-assignee-options', data);
};

/**
 * 获取指派人可选条件
 * @returns {Promise<undefined>}
 */
export const getBugFilter = async () => {
  return http.post('/issue-statistic/ring-diagram/filters');
};

/**
 * 获取指派人可选条件的选项
 * @returns {Promise<undefined>}
 */

export const getBugFilterOptions = async (data) => {
  return http.post('/issue-statistic/ring-diagram/filter-options', data);
};
/**
 * 获取 @ 的用户下拉列表数据
 * @param projectId
 * @returns {Promise<*>}
 */
export const getMemberList = async (projectId) => {
  return http.post(
    '/member/project-users',
    { projectId, containAccUnEnabled: true },
    { showError: false }
  );
};

/**
 * 获取项目issueType列表
 * @param projectId
 * @returns {Promise<*>}
 */
export const getIssueTypeList = async (projectId) => {
  return http.post(
    '/issue-type/list-selector/project-id',
    { projectId },
    { showError: false }
  );
};

//加载项目下布局字段
export async function loadIssueTypeFieldInfo(data) {
  // eslint-disable-next-line
  return http.post('/kanban/issue-type-basic-system-field-info', data);
}


/**
 * 获取燃起图统计维度列表
 * @param projectId
 * @returns {Promise<*>}
 */
export const getBurnIssueTypeList = async (projectId) => {
  return http.post(
    '/issue-type/list-selector/burn-project-id',
    { projectId },
    { showError: false }
  );
};

/**
 * 获取燃烧图类型列表
 * @returns {Promise<*>}
 */
export const getBurnTypeList = async () => {
  return http.get('/sys-home/get/burn-type');
};


/**
 * 获取燃烧图版本列表
 * @returns {Promise<*>}
 */
export const getBurnVersionList = async() => {
  return http.post('/sys-home/get/burn-up-config', {
    burnType: 1
  });
};

/**
 * 获取版本燃烧图下工作类型
 * @param data
 * @returns {Promise<*>}
 */
export const getBurnVersionIssueType = async (data) => {
  return http.post('/project-list/burn-config', data, {
    showError: false
  });
};

/**
 * 获取git类型
 *
 * @returns {Promise<*>}
 */
export const getGitType = async () => {
  return http.get('/open/git-statistic/git-type', {});
};

/**
 * 获取git项目列表
 *
 * @returns {Promise<*>}
 */
export const getGitProjectList = async (data) => {
  return http.post('/open/git-statistic/git-projects', data, {
    showError: false
  });
};

/**
 * 获取git项目成员列表
 * @param projectId
 * @returns {Promise<*>}
 */
export const getGitUserList = async (platform, projectIds) => {
  return http.post(`/open/git-statistic/${platform}/git-users`, { projectIds });
};

/**
 * 获取提交效率
 * @param data
 * @returns {Promise<*>}
 */
export const getGitCommitEfficiencyStatistics = async (platform, data) => {
  return http.post(
    `/open/git-statistic/${platform}/git-commit-efficiency`,
    data,
    { showError: false }
  );
};

/**
 * 获取合并次数
 * @param data
 * @returns {Promise<*>}
 */
export const getGitMergeTimesStatistics = async (data) => {
  return http.post('/open/git-statistic/git-merge-times', data, {
    showError: false
  });
};

/**
 * 获取等待时间分布 git merge等待
 * @param data
 * @returns {Promise<*>}
 */
export const getGitMergeWaitingTimeStatistics = async (data) => {
  return http.post('/open/git-statistic/git-merge-waiting-time', data, {
    showError: false
  });
};

/**
 * 获取工作流
 * @param data
 * @returns {Promise<*>}
 */
export const getListWorkGroup = async (data) => {
  return http.post('/issue-type/list-workflow-group/project-id', data);
};

/**
 * 获取im绑定和授权
 * @param data
 * @returns {Promise<*>}
 */
export const getImAndAuthorized = async () => {
  return http.post('/im/org/list/im-and-authorized');
};
/**
 * 统计数字组件-[事项类型]筛选条件数据
 * @param data
 * @returns {Promise<*>}
*/
export const getIssueTypes = async (data) => {
  return http.post('/issue-statistic/statistics-widget/issue-types', data, { showError: false });
};
/**
 * 统计数字组件-[计算方式]筛选条件数据
 * @param data
 * @returns {Promise<*>}
*/
export const getCalculateTypes = async () => {
  return http.post('/issue-statistic/statistics-widget/calculate-types');
};
/**
 * 统计数字组件-[统计字段]筛选条件数据
 * @param data
 * @returns {Promise<*>}
*/
export const getFields = async (data) => {
  return http.post('/issue-statistic/statistics-widget/fields', data);
};
/**
 * 统计数字组件-统计结果
 * @param data
 * @returns {Promise<*>}
*/
export const getResult = async (data, options) => {
  return http.post('/issue-statistic/statistics-widget/result', data, { showError: false, ...options });
};
/**
 * 获取饼图柱状图统计纬度
 * @return {Promise<*>}
 */
export const getGroupFields = async (data) => {
  return http.post('/issue-statistic/chart-widget/group-fields', data);
};
/**
 * 图表组件-[统计字段]筛选条件数据
 * @param data
 * @returns {Promise<*>}
*/
export const getStatisticFields = async (data) => {
  return http.post('/issue-statistic/chart-widget/statistic-fields', data);
};
/**
 * 图表组件-统计结果
 * @param data
 * @returns {Promise<*>}
*/
export const getChartWidgetResult = async (data, options) => {
  return http.post('/issue-statistic/chart-widget/result', data, { showError: false, ...options });
};
/**
 * 统计数字组件-根据组件类型id获取推荐的组件配置列表
 * @param data
 * @returns {Promise<*>}
*/
export const getRecommendSetting = async (data) => {
  return http.post('/sys-home-template/get-widget-recommend-setting-list', data);
};

/**
 * 统计数字组件-统计结果
 * @param data
 * @returns {Promise<*>}
*/
export const getRecommendInfo = async (data) => {
  return http.post('/sys-home-template/get-widget-recommend-setting', data);
};

/**
 * 统计数字组件-获取最近迭代
 * @param data
 * @returns {Promise<*>}
*/
export const getRecentSprint = async (data) => {
  return http.post('/sys-home/get-recent-sprint', data);
};

export const chartDetailFields = async (data) => {
  return http.post('/issue-statistic/chart-widget/detail-fields', data);
};

export const getHomeAssigneeHeaderField = async (data = { fieldCodes: [] }) => {
  return http.post('/sys-home/get/home-assignee-header-field', data);
};
